import React, { useState } from "react";
import StreamingTypeConfigForm from "../StreamingTypeConfigForm/StreamingTypeConfigForm";

const StreamingConfigModal = ({
  isVisible,
  onClose,
  products = [],
  onSaveModify, 
}) => {
  const [currentStep, setCurrentStep] = useState(0); 
  const [selectedAction, setSelectedAction] = useState(null); 

  if (!isVisible) return null;

  const handleSelectAction = (action) => {
    setSelectedAction(action);
    if (action === "create" || action === "modify") {
      setCurrentStep(1); 
    }
  };

  const handleBack = () => {
    if (currentStep === 1) {
      setCurrentStep(0); 
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      {/* max height + scroll: stream types can have many fields */}
      <div className="bg-gray-800 text-white rounded-lg shadow-lg w-full max-w-sm p-6 max-h-[90vh] overflow-y-auto">
        {currentStep === 0 && (
          <>
            <h2 className="text-xl font-bold mb-4 text-center">Streaming Configuration</h2>
            <div className="flex flex-col gap-4">
              {/* Botón para crear un nuevo streaming type */}
              <button
                onClick={() => handleSelectAction("create")}
                className="w-full bg-blue-600 hover:bg-blue-500 font-bold py-2 px-4 rounded-lg transition duration-300"
              >
                Create a New Streaming Type
              </button>
              {/* Botón para modificar un streaming type */}
              <button
                onClick={() => handleSelectAction("modify")}
                className="w-full bg-green-600 hover:bg-green-500 font-bold py-2 px-4 rounded-lg transition duration-300"
              >
                Modify a Streaming Type
              </button>
            </div>
            <div className="mt-4 flex justify-end">
              <button
                onClick={onClose}
                className="bg-gray-700 hover:bg-gray-600 font-bold py-2 px-4 rounded-lg transition duration-300"
              >
                Close
              </button>
            </div>
          </>
        )}

        {currentStep === 1 && (
          <StreamingTypeConfigForm
            dashboards={products}
            action={selectedAction} 
            onSave={(data) => {
              onSaveModify(data); 
              onClose(); 
            }}
            onCancel={handleBack} 
          />
        )}
      </div>
    </div>
  );
};

export default StreamingConfigModal;
